module.exports = __webpack_public_path__ + "static/media/8.4e708253.png";